/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Conversion_Error_Document_Type_UnsupportedInputs */

const en_conversion_error_document_type_unsupported = /** @type {(inputs: Conversion_Error_Document_Type_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This file format is not supported.`)
};

const es_conversion_error_document_type_unsupported = /** @type {(inputs: Conversion_Error_Document_Type_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este formato de archivo no es compatible.`)
};

/**
* | output |
* | --- |
* | "This file format is not supported." |
*
* @param {Conversion_Error_Document_Type_UnsupportedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const conversion_error_document_type_unsupported = /** @type {((inputs?: Conversion_Error_Document_Type_UnsupportedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversion_Error_Document_Type_UnsupportedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_conversion_error_document_type_unsupported(inputs)
	return en_conversion_error_document_type_unsupported(inputs)
});